import React from 'react'

const NoPage = () => {
  return (
    <div>
      <h1>Page does not exist :.)</h1>
    </div>
  )
}

export default NoPage
